module.exports = __webpack_public_path__ + "static/img/keyboard.fdb6141.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/keyboard.png
// module id = KDcO
// module chunks = 1